import { render, staticRenderFns } from "./ChevronsButton.vue?vue&type=template&id=1863e73a&scoped=true&"
import script from "./ChevronsButton.vue?vue&type=script&lang=ts&"
export * from "./ChevronsButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChevronsButton.vue?vue&type=style&index=0&id=1863e73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863e73a",
  null
  
)

export default component.exports